import Header from 'components/hoc/Header/Header';
import Sidebar from 'components/hoc/Sidebar/Sidebar';
import styles from './Layout.module.scss';
import { useState, useContext } from 'react';
import OverviewContext from 'store/overview-context';
import { Loader, Toaster } from 'components/generic';

const Layout = props => {
	const [sidebarToggle, setSidebarToggle] = useState(false);
	const overviewContext = useContext(OverviewContext);
	const { toasterMsg, isLoading, setToasterMsg } = overviewContext;

	const sidebarToggler = () => {
		setSidebarToggle(prevState => !prevState);
	};

	return (
		<>
			{isLoading && <Loader loading={isLoading} />}
			<div className={styles.container}>
				<div className={styles.container__content}>
					<Header />
					<Sidebar sidebarToggle={sidebarToggle} onCloseSidebar={sidebarToggler} />
					<div className={styles.container__children}>{props.children}</div>
					{toasterMsg && (
						<Toaster
							information={toasterMsg?.information}
							error={toasterMsg?.error}
							success={toasterMsg?.success}
							warning={toasterMsg?.warning}
							center={toasterMsg?.center}
							header={toasterMsg?.header}
							content={toasterMsg?.content}
							undo={toasterMsg?.undo}
							buttontext={toasterMsg?.buttontext}
							hideclose={toasterMsg?.hideclose}
							handleUndoClose={() => setToasterMsg(null)}
							top={toasterMsg?.top}
						/>
					)}
				</div>
			</div>
		</>
	);
};

export default Layout;
